import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FileText, Cog, Wrench, BarChart3 } from 'lucide-react'
import SpotlightTour from '../tour/SpotlightTour'
import { dashboardSteps } from '../tour/tour-steps'
import { useTourState } from '../../hooks/useTourState'

const cards = [
  {
    to: '/dashboard/projects',
    icon: FileText,
    title: 'Projects',
    description: 'Your G-code generation projects',
  },
  {
    to: '/dashboard/machines',
    icon: Cog,
    title: 'Machines',
    description: 'Machine profiles and configurations',
  },
  {
    to: '/dashboard/tools',
    icon: Wrench,
    title: 'Tools',
    description: 'Tool inventory and libraries',
  },
  {
    to: '/dashboard/usage',
    icon: BarChart3,
    title: 'Usage',
    description: 'Quota and API usage',
  },
] as const

export default function DashboardHome() {
  const [showTour, setShowTour] = useState(false)
  const { shouldShow, markSeen } = useTourState()

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        {cards.map(({ to, icon: Icon, title, description }) => (
          <Link
            key={to}
            to={to}
            className="glass rounded-xl p-8 pt-10 pb-10 hover:border-cyan-500/30 transition-all duration-150 group cursor-pointer"
          >
            <div className="w-12 h-12 rounded-xl bg-cyan-500/10 flex items-center justify-center mb-6 group-hover:bg-cyan-500/15 transition-colors duration-150">
              <Icon className="w-6 h-6 text-cyan-500/70 group-hover:text-cyan-400 transition-colors duration-150" />
            </div>
            <div className="font-mono text-base text-slate-200 mb-1">{title}</div>
            <div className="font-mono text-sm text-slate-500">{description}</div>
          </Link>
        ))}
      </div>
      {shouldShow('dashboard') && !showTour && (
        <div className="mt-4 text-center">
          <button
            onClick={() => setShowTour(true)}
            className="font-mono text-xs text-cyan-400/60 hover:text-cyan-400 transition-colors"
          >
            Take a tour of the dashboard
          </button>
        </div>
      )}
      {showTour && (
        <SpotlightTour
          steps={dashboardSteps}
          active={showTour}
          onComplete={() => { markSeen('dashboard'); setShowTour(false) }}
          onSkip={() => { markSeen('dashboard'); setShowTour(false) }}
        />
      )}
    </>
  )
}
